import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import './style.css';

import { Link } from 'react-router-dom';
// import { ROUTE_NAMES } from '../../Routes';

// import GetInTouchSection from '../../Components/GetInTouchSection';
// import StayConnected from '../../Components/StayConnectedSection';

// import RightArrow from '../../assets/images/right-arrow.png';
import DownloadPDFSection from '../../Components/DownloadPDFSection';

export default function EBService() {
	const location = useLocation();

	const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

	return (
		<div className='eb-page'>
			<Helmet>
				<title>Starlife: EB5 Investment Opportunity at 21 Hollywood</title>
				<meta
					name='description'
					content='Explore the EB-5 program with Starlife Group for US residency through investment. Secure your future by investing in exclusive real estate projects and gain US residency.'
				/>
				<meta
					name='keywords'
					content='EB-5 Visa, US Residency through Investment, Real estate investment for US residency, Starlife EB-5 program, US green card investment, Immigrant investor program'
				/>
				<link rel='canonical' href={canonicalUrl} />
			</Helmet>
			<div className='service-context'>
				<h2 className='service-page-title'>
					EB-5 Immigration Investment Program
				</h2>
				<p className='service-page-text'>
					Starlife Group proudly offers access to the EB-5 Immigrant Investor
					Program, a U.S. government initiative that provides eligible foreign
					investors the opportunity to obtain permanent residency through
					job-creating real estate investments.
				</p>
				<p className='service-page-text'>
					Our featured project, 21 Hollywood, is a multiple award-winning,
					USCIS-compliant development located in a targeted employment area
					(TEA) in South Florida.
				</p>
				<p className='service-page-text'>
					By investing in this transformative mixed-use property, investors not
					only contribute to local economic growth but also gain a potential
					path to a green card for themselves, their spouse, and unmarried
					children under 21.
				</p>
			</div>
			<div className='our-services-section'>
				<h2 className='section-title'>Benefits of the EB5 Program</h2>
				<div className='service-list'>
					<Link
						// to={ROUTE_NAMES.CAPITALVENTURES}
						className='service-block green-block'
					>
						<h3>
							U.S. green cards for investor, spouse, and children under 21
						</h3>
						{/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
					</Link>
					<Link
						// to={ROUTE_NAMES.LENDINGSOLUTIONS}
						className='service-block'
					>
						<h3>No sponsor or employer requirement</h3>
						{/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
					</Link>
					<Link
						// to={ROUTE_NAMES.CAPITALVENTURES}
						className='service-block green-block'
					>
						<h3>Freedom to live, work, and study anywhere in the U.S.</h3>
						{/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
					</Link>
					<Link
						// to={ROUTE_NAMES.LENDINGSOLUTIONS}
						className='service-block'
					>
						<h3>Access to top education and healthcare</h3>
						{/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
					</Link>
					<Link
						// to={ROUTE_NAMES.CAPITALVENTURES}
						className='service-block green-block'
					>
						<h3>Pathway to U.S. citizenship</h3>
						{/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
					</Link>
				</div>
			</div>
			<DownloadPDFSection />
			{/* <GetInTouchSection /> */}
			{/* <StayConnected /> */}
		</div>
	);
}
